const c = () => !!document.querySelector('script[src*="/recaptcha/"]:not([src*="gstatic"])');
export {
  c as checkGoogleReCaptchaInjected
};
//# sourceMappingURL=checkGoogleReCaptchaInjected.js.map
